import React, { Component, Fragment } from 'react';
import propTypes from 'prop-types';
import { Label, Input } from 'reactstrap';

import { expNameField } from 'lib/contract/experiment';

/**
 * handle experiment parameter lookup
 */
export default class ExperimentDetails extends Component {
  static propTypes = {
    clearExperiment: propTypes.func.isRequired,
    experimentName: propTypes.string.isRequired,
    fetchExperiment: propTypes.func.isRequired,
    id: propTypes.string.isRequired,
    isReadonly: propTypes.bool,
    modify: propTypes.func.isRequired
  };

  static defaultProps = {
    isReadonly: false
  };

  constructor(props) {
    super(props);

    this.state = {
      experimentName: props.experimentName || ''
    };

    this.handleExperimentNameChange = this.handleExperimentNameChange.bind(this);
    this.handleTextInputChange = this.handleTextInputChange.bind(this);
  }

  /**
   * change experiment name
   * @param {object} event - input event with the new experiment name
   */
  handleExperimentNameChange(event) {
    const { clearExperiment, fetchExperiment, id, modify } = this.props;

    if (modify) {
      modify(event.target.value.trim(), expNameField.propLocation, id);
    }

    if (event.target.value.trim().length) {
      fetchExperiment(event.target.value.trim());
    } else {
      clearExperiment();
    }
  }

  /**
   * update internal state for text inputs
   * @param {object} event - text input event
   */
  handleTextInputChange(event) {
    const { value } = event.target;
    this.setState({ experimentName: value });
  }

  render() {
    return (
      <Fragment>
        <Label className="font-weight-bold mt-3">{expNameField.name}</Label>
        <Input
          className="rounded"
          name="experimentName"
          type="text"
          value={this.state.experimentName}
          onChange={this.handleTextInputChange}
          onBlur={this.handleExperimentNameChange}
          disabled={this.props.isReadonly}
          data-test-id="experimentDetails-name-input"
        />
      </Fragment>
    );
  }
}
